module.exports = "<div class=\"dashboard\" >\n  <div class=\"layout\">\n<app-menurecursos #menuRecursos [fixed]=\"true\"></app-menurecursos>\n<div class=\"content\">\n\n  <div class=\"container container-left \">\n      <div class=\"col col-two-third\">\n        <div style=\"width:60%;position: relative;\" >\n            <app-diagnosticos-lista [currentClient]=\"this.currentClient\" ></app-diagnosticos-lista>\n        </div>\n      </div>\n  </div>\n</div>\n</div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard-diagnostico/dashboard-diagnostico.component.html
// module id = ./src/app/dashboard-diagnostico/dashboard-diagnostico.component.html
// module chunks = main